module.exports = __webpack_public_path__ + "img/mockup-move-apps-FR.5863f6cb.png";